import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyWalletList, dummyCoinList } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./ExchangeWalletPage.css";

const ExchangeWalletPage = () => {
  const [wallets] = useState(dummyWalletList);
  const [coins] = useState(dummyCoinList);
  const [walletSearch, setWalletSearch] = useState("");
  const [selectedCoin, setSelectedCoin] = useState("USDT");
  const [chainFilter, setChainFilter] = useState("");
  const [, setChainListSubmitted] = useState(false);

  const filteredWallets = wallets.filter(
    (w) =>
      w.userId?.toLowerCase().includes(walletSearch.toLowerCase()) ||
      w.emailId?.toLowerCase().includes(walletSearch.toLowerCase()) ||
      w.short_name?.toLowerCase().includes(walletSearch.toLowerCase())
  );

  const handleChainListSubmit = (e) => {
    e.preventDefault();
    setChainListSubmitted(true);
  };

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Exchange Wallet</span>
          </p>
          <h1 className="dashboard-hero__title">Exchange Wallet</h1>
          <p className="dashboard-hero__subtitle">
            View exchange wallet balances and supported coins
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-wallet" />
        </div>
      </section>

      <div className="dashboard-body">
        {/* Wallet list */}
        <section className="exwallet-section">
          <div className="exwallet-section__header">
            <div className="exwallet-section__title-wrap">
              <span className="exwallet-section__icon">
                <i className="fas fa-coins" />
              </span>
              <h2 className="exwallet-section__title">Wallet Balances</h2>
            </div>
            <div className="exwallet-section__stats">
              <span className="exwallet-stat">
                <strong>{wallets.length}</strong> Wallets
              </span>
            </div>
          </div>

          <div className="exwallet-toolbar">
            <form className="exwallet-chain-form" onSubmit={handleChainListSubmit}>
              <select
                className="exwallet-chain-select"
                value={selectedCoin}
                onChange={(e) => setSelectedCoin(e.target.value)}
                aria-label="Select currency"
              >
                {coins.map((c) => (
                  <option key={c._id} value={c.short_name}>{c.short_name}</option>
                ))}
              </select>
              <input
                type="text"
                className="exwallet-chain-input"
                placeholder="main"
                value={chainFilter}
                onChange={(e) => setChainFilter(e.target.value)}
                aria-label="Chain or wallet type"
              />
              <button type="submit" className="exwallet-chain-submit">
                <i className="fas fa-search" /> Submit
              </button>
            </form>
            <div className="exwallet-search-wrap">
              <i className="fas fa-search" />
              <input
                type="text"
                placeholder="Search by user ID, email or currency..."
                value={walletSearch}
                onChange={(e) => setWalletSearch(e.target.value)}
                className="exwallet-search-input"
              />
            </div>
          </div>
          <div className="exwallet-table-wrap">
            <table className="exwallet-table">
              <thead>
                <tr>
                  <th>Wallet ID</th>
                  <th>User ID</th>
                  <th>Email</th>
                  <th>Currency</th>
                  <th>Balance</th>
                  <th>Locked Balance</th>
                  <th>Currency ID</th>
                </tr>
              </thead>
              <tbody>
                {filteredWallets.map((row) => (
                  <tr key={row._id}>
                    <td><span className="exwallet-mono">{row._id}</span></td>
                    <td><span className="exwallet-mono">{row.userId}</span></td>
                    <td>{row.emailId}</td>
                    <td><strong>{row.short_name}</strong></td>
                    <td>{typeof row.balance === "number" ? row.balance.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : row.balance}</td>
                    <td>{typeof row.locked_balance === "number" ? row.locked_balance.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : row.locked_balance}</td>
                    <td><span className="exwallet-mono">{row.currency_id}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filteredWallets.length === 0 && (
            <p className="exwallet-empty">No wallets match your search.</p>
          )}
        </section>

        {/* Coin list - with dropdown + main input + Submit */}

      </div>
    </main>
  );
};

export default ExchangeWalletPage;
